'use client';

import type { ReactNode } from 'react';

type Props = {
  index: number;
  children: ReactNode;
  onDragStartAction: (index: number) => void;
  onDragOverAction?: (index: number) => void;
  onDragEndAction?: () => void;
  onDropAction: (fromIndex: number, toIndex: number) => void;
};

export default function ProductsComparisonDragWrapper({
  index,
  children,
  onDragStartAction,
  onDragOverAction,
  onDragEndAction,
  onDropAction,
}: Props) {
  return (
    <div
      draggable
      onDragStart={(e) => {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(index));
        onDragStartAction(index);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        onDragOverAction?.(index);
      }}
      onDrop={(e) => {
        e.preventDefault();
        const fromIndex = Number.parseInt(e.dataTransfer.getData('text/plain'), 10);
        onDropAction(fromIndex, index);
      }}
      onDragEnd={() => {
        onDragEndAction?.();
      }}
      className="transition-transform duration-200 ease-in-out"
    >
      {children}
    </div>
  );
}
